export default "__VITE_ASSET__$88AE0U5__"